import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Statistics from "../components/Statistics";
import ContactUsHomeForm from "../components/dashboard components/forms/ContactUsHomeForm";
import Footer from "../components/Footer";

// ✅ Use environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const HomePage = () => {
  const [heroSlides, setHeroSlides] = useState([]);
  const [aboutData, setAboutData] = useState({});
  const [projects, setProjects] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [trustbarStats, setTrustbarStats] = useState([]);

  useEffect(() => {
    fetchHeroSlides();
    fetchAboutData();
    fetchProjects();
    fetchTestimonials();
    fetchFaqs();
    fetchTrustbarStats();
  }, []);

  // ===========================================
  // Fetch Hero Section
  // ===========================================
  const fetchHeroSlides = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/home/hero`);
      setHeroSlides(res.data || []);
    } catch (err) {
      console.error("Error fetching hero:", err);
    }
  };

  // ===========================================
  // Fetch About Section
  // ===========================================
  const fetchAboutData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/home/about`);
      setAboutData(res.data || {});
    } catch (err) {
      console.error("Error fetching about:", err);
    }
  };

  // ===========================================
  // Fetch Projects
  // ===========================================
  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/home/project`);
      console.log("preoject res",res)
      setProjects(res.data || []);
    } catch (err) {
      console.error("Error fetching projects:", err);
    }
  };

  // ===========================================
  // Fetch Testimonials
  // ===========================================
  const fetchTestimonials = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/home/testimonials`);
      setTestimonials(res.data || []);
    } catch (err) {
      console.error("Error fetching testimonials:", err);
    }
  };

  // ===========================================
  // Fetch FAQs
  // ===========================================
  const fetchFaqs = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/home/faq`);
      setFaqs(res.data || []);
    } catch (err) {
      console.error("Error fetching FAQ:", err);
    }
  };

  // ===========================================
  // Fetch Trustbar / Statistics
  // ===========================================
  const fetchTrustbarStats = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/trustbar`);
      setTrustbarStats(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching trustbar stats:", err);
      setTrustbarStats([]);
    }
  };

  // ===========================================
  // JSX
  // ===========================================
  return (
    <div className="bg-white min-h-screen flex flex-col overflow-x-hidden">
      <Header />

      <main className="flex-1">
        {/* Hero */}
        <section>
          <Hero slides={heroSlides} />
        </section>

        {/* Trustbar / Statistics */}
        {trustbarStats.length > 0 && (
          <section className="bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 py-8">
              <Statistics stats={trustbarStats} />
            </div>
          </section>
        )}

        {/* About Section */}
        {aboutData?.title && (
          <section>
            <About
              subtitle={aboutData.subtitle}
              title={aboutData.title}
              description={aboutData.description}
              image={aboutData.image}
              buttonLabel={aboutData.button}
              buttonLink="/about"
              reverse
              showImage
              showButton
            />
          </section>
        )}

        {/* Projects Section */}
        {projects.length > 0 && (
          <section className="bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 py-12">
              <Projects projects={projects} />
            </div>
          </section>
        )}

        {/* Testimonials */}
        {testimonials.length > 0 && (
          <section>
            <Testimonials testimonials={testimonials} />
          </section>
        )}

 

        {/* Contact Section */}
        <section className="bg-gray-50">
          <div className="max-w-5xl mx-auto px-4 py-12">
            <ContactUsHomeForm />
          </div>
        </section>


               {/* FAQ Section */}
        {faqs.length > 0 && (
          <section className="bg-white py-16">
            <div className="max-w-6xl mx-auto px-4">
              <h2 className="text-3xl font-bold text-blue-700 mb-6 text-center">
                Frequently Asked Questions
              </h2>
              <p className="text-gray-600 mb-10 text-center max-w-3xl mx-auto">
                Clear answers to the most common queries about approvals, loans, and customization.
              </p>
              <div className="space-y-4">
                {faqs.map((faq) => (
                  <FAQ key={faq.faq_id} faq={faq} />
                ))}
              </div>
            </div>
          </section>
        )}
        
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
